module.exports = __webpack_public_path__ + "72d7b2641de0c7ddea9491ff2c415fa4.svg";


//////////////////
// WEBPACK FOOTER
// ./static/icons/succsessPublish.svg
// module id = 1313
// module chunks = 0